import { Controller } from "@hotwired/stimulus"
import { sort_elements } from '../../../../frontend/xinspire/sort'

export default class extends Controller {
  connect() {
    sort_elements(this.element, '.sort-cards', ['status', 'name'], ['asc', 'asc']);
    this.element.classList.add('loaded')
  }
}
